import React, { Component } from 'react';
import every from 'lodash/every';
import { SingleFeatureField, GroupFeatureField, IncludedAwardsField, ExtraAwardsField } from
  'pap/components/common/input_fields/package_fields';
import { PACKAGE_ITEMS } from 'pap/ducks/workflow';

/*
 * Generic component used to render steps that customize package features/awards.
 * A list of items can be explicitly passed OR a step name, in which case
 * all items from the given step will be rendered.
 *
 * @author: Nathan Ozelim <nathan@startupfoundry.com>
*/
export class PackageOptions extends Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  updateBundles(fieldName, value, currentValue, updates) {
    const { input, currentFeatures } = this.props;

    if (value !== true) {
      return;
    }

    const item = PACKAGE_ITEMS.find(i => i.fieldName === fieldName);
    const bundledIn = PACKAGE_ITEMS.find(item => (
      (item.bundles || []).includes(fieldName) &&
      !!(currentFeatures || []).find(f => f.feature.name === item.name)
    ));

    const isItemActive = (item) => {
      if (item.fieldName === fieldName) {
        return !!value;
      }

      const fieldValue = currentValue[item.fieldName];
      const feature = currentFeatures.find(f => f.feature.name === item.name);

      if (!feature) {
        return false;
      }

      return fieldValue === undefined? feature.feature.active : !!fieldValue;
    };

    /* checked feature is part of a bundle */
    if (bundledIn) {
      const allBundleItemsActive = every(bundledIn.bundles, (
        fieldName => isItemActive(PACKAGE_ITEMS.find(i => i.fieldName === fieldName))
      ));

      /* if all child features are checked, uncheck them all and check the bundle instead */
      if (allBundleItemsActive) {
        updates[bundledIn.fieldName] = true;
        bundledIn.bundles.forEach(fieldName => updates[fieldName] = false);
      /* otherwise, uncheck the bundle */
      } else {
        updates[bundledIn.fieldName] = false;
      }
    }

    /* checked feature is a bundle: uncheck all child features */
    if (item) {
      (item.bundles || []).forEach(fieldName => updates[fieldName] = false);
    }
  }

  onChange(fieldName, value) {
    const { input } = this.props;
    const currentValue = input.value || {};
    const updates = {
      [fieldName]: value
    };

    this.updateBundles(fieldName, value, currentValue, updates);

    input.onChange({ ...currentValue, ...updates });
  }

  render () {
    const { currentFeatures, currentAwards, projectData, input, downgradeForbidden, meta,
      step, awardedCreatives, user } = this.props;

    const commonFieldProps = {
      features: currentFeatures,
      awards: currentAwards,
      projectData: projectData,
      billables: projectData? projectData.billables : null,
      stepValues: input.value || {},
      downgradeForbidden: downgradeForbidden || false,
      awardedCreatives: awardedCreatives || [],
      onChange: this.onChange,
      error: meta.error,
      user
    }
    /* use given items if provided, otherwise get all items for the specified step */
    const items = this.props.items || PACKAGE_ITEMS.filter((f) => f.step == step)

    return (
      <div className="package-options">
        {items.map((item, i) => {
          /* decide which field to use based on item properties */
          let Field = null

          if (item.fieldName == 'included_awards') {
            Field = IncludedAwardsField  // included awards
          } else if (item.fieldName == 'extra_awards') {
            Field = ExtraAwardsField  // extra awards
          } else if (item.isGroup) {
            Field = GroupFeatureField  // feature group
          } else {
            Field = SingleFeatureField  // single feature
          }

          return (
            <Field key={i} {...commonFieldProps}
              fieldName={item.fieldName}
              name={item.name}
              groupLabel={item.groupLabel}
              getGroupDescription={item.getGroupDescription}
              disclaimer={item.disclaimer}
              recommended={item.recommended}
              displayName={item.displayName}
              projectFields={item.projectFields || []}
              extraComponent={item.extraComponent}
          />);
        })}
      </div>
    );
  }
};

export const PromotionOptions = (props) => <PackageOptions {...props} step="promotion_options" />
export const ProjectOptions = (props) => <PackageOptions {...props} step="project_options" />
export const ProtectionOptions = (props) => <PackageOptions {...props} step="protection_options" />
export const AwardOptions = (props) => <PackageOptions {...props} step="award_options" />
